import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { filter, pipe, Subscription, switchMap, takeUntil, tap, withLatestFrom } from 'rxjs';
import { AnswerOptionItem } from '../models/answerOptionItem.model';
import { OptionsListApiService } from '../features/collections/services/options-list-api.service';
;
import { QuestionApiService } from 'src/app/services/question-api.service';
import { QuestionType } from 'src/app/models/questionType.model';
import { OptionsList, OptionsListGridItem } from 'src/app/models/optionsList.model';
export interface OptionsListState {
    readonly optionLists: OptionsListGridItem[];
    readonly currentList?: AnswerOptionItem[];
    readonly currentListId?: string;
    readonly loading: boolean;
    error?: string;
    // readonly questionTypes: QuestionType[];
}

export class OptionsListStore extends ComponentStore<OptionsListState> {

    #optionsListApiService = inject(OptionsListApiService);
    constructor() {
        super({
            // questionTypes: [],
            optionLists: [],
            loading: false,
        });
        this.fetchOptionLists();
        // this.fetchQuestionType();
        this.currentListId$.pipe(
            filter(x => x != undefined),
            takeUntil(this.destroy$))
            .subscribe(x => {
                this.loadCurrentList()
            });
    }
    readonly optionLists$ = this.select(({ optionLists }) => optionLists);
    readonly currentList$ = this.select(({ currentList }) => currentList);
    readonly currentListId$ = this.select(({ currentListId }) => currentListId);
    // readonly questionTypes$ = this.select(({ questionTypes }) => questionTypes);

    readonly fetchOptionLists = this.effect<void>(
        pipe(
            tap(() => this.patchState({ loading: true })),
            switchMap(() =>
                this.#optionsListApiService.getAllOptionsLists().pipe(
                    tapResponse(
                        (optionLists) => this.patchState({ optionLists, loading: false }),
                        (error: Error) =>
                            this.patchState({ error: error?.message, loading: false })
                    )
                )
            )
        )
    );
    // readonly fetchQuestionType = this.effect<void>(
    //     pipe(
    //         tap(() => this.patchState({ loading: true })),
    //         switchMap(() =>
    //             this.#questionApiService.getQuestionTypes().pipe(
    //                 tapResponse(
    //                     (questionTypes) => this.patchState({ questionTypes, loading: false }),
    //                     (error: Error) =>
    //                         this.patchState({ error: error?.message, loading: false })
    //                 )
    //             )
    //         )
    //     )
    // );
    readonly updateCurrentListId = this.updater((state, data: string) => {

        return {
            ...state,
            currentListId: data,
        };
    });
    readonly loadCurrentList = this.effect<void>(
        pipe(
            tap(() => this.patchState({ loading: true })),
            withLatestFrom(this.currentListId$),
            filter(([_, x]) => x != undefined),
            switchMap(([_, guid]) => {
                return this.#optionsListApiService.getItemsByListId(guid!).pipe(
                    tapResponse(
                        (currentList) => this.patchState({ currentList, loading: false }),
                        (error: Error) =>
                            this.patchState({ error: error?.message, loading: false })
                    )
                )
            }
            )
        )
    );
    readonly createList = this.effect<OptionsList>((newList) =>
        newList.pipe(
            tap(() => this.patchState({ loading: true })),
            switchMap((newList) =>
                this.#optionsListApiService.createNewList(newList).pipe(
                    tapResponse(
                        (list) => {
                            this.patchState({ loading: false })
                            if (list)
                                this.fetchOptionLists();
                        },
                        (error: Error) =>
                            this.patchState({ error: error?.message, loading: false })
                    )
                )
            )
        )
    );
    // readonly getItemsByListId= this.effect<number>((id) =>{
    //     id.pipe(
    //         tap(() => this.patchState({ loading: true })),
    //         switchMap((id) =>
    //             this.#optionsListApiService.getItemsByListId(id).pipe(
    //                 tapResponse(
    //                     (list) => {
    //                         this.patchState({ loading: false })
    //                         if (list)
    //                             this.fetchOptionLists();
    //                     },
    //                     (error: Error) =>
    //                         this.patchState({ error: error?.message, loading: false })
    //                 )
    //             )
    //         )
    //     )
    //   })
    readonly addItemToCurrentList = this.effect<AnswerOptionItem>((newItem) =>
        newItem.pipe(
            tap(() => this.patchState({ loading: true })),
            withLatestFrom(this.currentListId$),
            filter(([_, x]) => x != undefined),
            switchMap(([newItem, guid]) => {
                return this.#optionsListApiService.addItemToList(guid!, newItem).pipe(
                    tapResponse(
                        (item) => {
                            this.patchState({ loading: false })
                            if (item)
                                this.loadCurrentList();
                        },
                        (error: Error) =>
                            this.patchState({ error: error?.message, loading: false })
                    )
                )
            }
            )
        )
    );
    readonly deleteItemFromList = this.effect<AnswerOptionItem>((item) =>
        item.pipe(
            tap(() => this.patchState({ loading: true })),
            switchMap((item) =>
                this.#optionsListApiService.deleteItemFromList(item.guid).pipe(
                    tapResponse(
                        (item) => {
                            this.patchState({ loading: false })
                            if (item)
                                this.loadCurrentList();
                        },
                        (error: Error) =>
                            this.patchState({ error: error?.message, loading: false })
                    )
                )
            )
        )
    );
}
